<template>
  <div>

    <!--section Banner-->
    <diapo/>

    <!--Chiffres clés-->
    <section class="statsSection">
      <v-row class="d-flex justify-center statsRow">
        <v-col class="statItem txt-c" v-for="(stat, i) in stats" :key="'stat'+i">
          <div class="statNumber">{{ stat.number }}</div>
          <div class="statLabel">{{ stat.label }}</div>
        </v-col>
      </v-row>
    </section>
    <!--TypeWater-->
    <section>
      <div id="rowAnimation">
        <v-row class="d-flex justify-center mb-6 gridpad">
              <v-col  cols="12" lg="4">
                <div class="scroll-textes" ref="observedCampaign" id="campaign" :class="{ 'is-visible': campaignVisible  }">
                  <v-row>
                    <v-col> 
                      <div class="txt-c"><span class="sectionTypeWaterLink">{{ $t('typeService.residentialTitle') }}</span></div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="bgSectionTypeWaterPhoto1"></div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="txt-j pa-2">
                      <p v-html="$t('typeService.residentialText')"></p>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" lg="4">
                <div class="scroll-textes" ref="observedTown" id="town" :class="{ 'is-visible': townVisible }">
                  <v-row>
                    <v-col><div class="txt-c"><span class="sectionTypeWaterLink">{{ $t('typeService.urbanTitle') }}</span></div></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="bgSectionTypeWaterPhoto2"></div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="txt-j pa-2">
                      <p v-html="$t('typeService.urbanText')"></p>
                    </v-col>
                  </v-row>
                </div>
              </v-col>

              <v-col cols="12" lg="4">
                <div class="scroll-textes" ref="observedWaterMachine" id="waterMachine"  :class="{ 'is-visible': waterMachineVisible }">
                  <v-row>
                    <v-col><div class="txt-c"><router-link to="/laveuse_haute_pression" class="sectionTypeWaterLink hover">{{ $t('typeService.pressureTitle') }}</router-link></div></v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div class="bgSectionTypeWaterPhoto3"></div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="txt-j pa-2">
                      <p v-html="$t('typeService.pressureText')"></p>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
        </v-row>
      </div>

      <v-row class="d-flex justify-center mb-6 gridpad">
        <v-col>
          <div class="scroll-textes-right" ref="observedAgricultural" id="agricultural" :class="{ 'is-visible': agriculturalVisible }">
            <v-row>
              <v-col>
                <div class="titleAgricole"><span class="sectionTypeWaterLink">{{ $t('typeService.aCIndustrialTitle') }}</span></div>
              </v-col>
              
            </v-row>
            <v-row>
              <v-col cols="12" lg="4">
                <div class="bgSectionTypeWaterPhoto4"></div>
              </v-col>
              <v-col class="txt-j">
                  <p class="textACTop" v-html="$t('typeService.aCIndustrialText')"></p>
              </v-col>
            </v-row>
          </div>
        </v-col>
        
      </v-row>
    </section>
    <!--Forage-->
    <section class="forageSection">
      <v-row class="d-flex align-stretch ma-0">
        <v-col cols="12" lg="6" class="forageLeft pa-0">
          <div class="forageTextWrap">
            <h2 class="forageTitle">Forage de puits, pompe et traitement d'eau : <span class="forageTitleAccent">une seule compagnie Bisson Service</span></h2>
            <p class="forageText">Chez Bisson Service, nous offrons un service tout inclus pour répondre à vos besoins en eau. Du forage de votre puits à l'installation complète du système de pompage et de traitement de l'eau, nous prenons tout en charge pour vous offrir une solution clé en main. Faites confiance à notre expertise pour une eau de qualité, directement chez vous!</p>
            <div class="forageServicesLabel">Nos services</div>
            <div class="forageServicesGrid">
              <div class="forageServiceItem" v-for="(item, i) in forageServices" :key="i">
                <span class="forageCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span class="forageServiceText">{{ item }}</span>
              </div>
            </div>
            <div class="foragePhotosRow">
              <div class="forageThumb" v-for="(p, i) in foragePhotos" :key="i" :style="{ backgroundImage: 'url(' + p + ')' }"></div>
            </div>
            <router-link class="forageBtn" to="/forage">En savoir plus →</router-link>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 forageRight">
          <div class="forageImgWrap">
            <div class="forageImg" :style="{ backgroundImage: 'url(/Resources/images/Forage/forageBanner.jpg)' }"></div>
          </div>
        </v-col>
      </v-row>
      <!-- Bande bleue avec profondeur 3D -->
      <svg class="forageBandSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 800" preserveAspectRatio="none">
        <defs>
          <!-- Dégradé horizontal : foncé gauche → vif centre → foncé droite -->
          <linearGradient id="bandDepth" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stop-color="rgb(8,45,110)"/>
            <stop offset="25%"  stop-color="rgb(15,82,163)"/>
            <stop offset="50%"  stop-color="rgb(30,120,220)"/>
            <stop offset="75%"  stop-color="rgb(15,82,163)"/>
            <stop offset="100%" stop-color="rgb(8,45,110)"/>
          </linearGradient>
          <!-- Reflet blanc brillant au centre -->
          <linearGradient id="bandShine" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   stop-color="rgba(255,255,255,0)"/>
            <stop offset="40%"  stop-color="rgba(255,255,255,0)"/>
            <stop offset="55%"  stop-color="rgba(255,255,255,0.25)"/>
            <stop offset="65%"  stop-color="rgba(255,255,255,0.10)"/>
            <stop offset="100%" stop-color="rgba(255,255,255,0)"/>
          </linearGradient>
        </defs>

        <!-- Fond blanc côté gauche -->
        <path d="M0,0 L22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L0,800 Z" fill="#f5f7fa"/>

        <!-- Corps principal de la bande avec dégradé profondeur -->
        <path d="M22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L40,800 C45,760 48,700 42,600 C20,400 55,200 40,0 Z" fill="url(#bandDepth)"/>

        <!-- Couche de reflet brillant par-dessus -->
        <path d="M22,0 C45,200 5,400 28,600 C38,700 35,760 22,800 L40,800 C45,760 48,700 42,600 C20,400 55,200 40,0 Z" fill="url(#bandShine)"/>
      </svg>
    </section>
    <!--v1.2 Pumps-->
    <section>  
      <pumps/>
    </section>
    <!--CTA Banner parallax-->
    <section class="ctaBanner">
      <div class="ctaOverlay">
        <h2 class="ctaTitle">Bisson Service</h2>
        <h3 class="ctaSubtitleSmall">Une troisième génération à votre service.</h3>
        <p class="ctaText">En 1958, Bisson Service se donnait le mandat de régler <strong>tous les soucis</strong> de ses clients en ce qui a trait à leur eau potable. Depuis plus de 60 ans, cette mission est encore bien présente, et c'est avec fierté que la troisième génération poursuit la tradition.</p>
        <div class="ctaBtns">
          <router-link class="ctaBtnPrimary" to="/experts">Notre équipe</router-link>
          <router-link class="ctaBtnSecondary" to="/contact">Nous contacter</router-link>
        </div>
      </div>
    </section>

    
    <!--v1.2 Skills-->
    <section style="">
      <services/>
    </section>

    <!--Témoignages-->
    <section class="testimonialsSection">
      <v-row class="d-flex justify-center mb-10">
        <v-col cols="12" class="txt-c">
          <p class="testimonialsTag">Ce que disent nos clients</p>
          <h2 class="testimonialsTitle">Ils nous font confiance</h2>
          <div class="testimonialsStars">
            <span v-for="i in 5" :key="i" class="starIcon">★</span>
            <span class="testimonialsRating">4.9 / 5 sur Google</span>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center testimonialsRow">
        <v-col cols="12" lg="4" md="6" v-for="(t, i) in testimonials" :key="i" class="testimonialsCol">
          <div class="testimonialCard">
            <div class="testimonialHeader">
              <div class="testimonialAvatar">{{ t.name.charAt(0) }}</div>
              <div class="testimonialMeta">
                <p class="testimonialName">{{ t.name }}</p>
                <p class="testimonialDate">{{ t.date }}</p>
              </div>
              <div class="testimonialGoogleIcon">
                <svg width="20" height="20" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
              </div>
            </div>
            <div class="testimonialStars">
              <span v-for="s in 5" :key="s" class="starIconSmall">★</span>
            </div>
            <p class="testimonialText">"{{ t.text }}"</p>
          </div>
        </v-col>
      </v-row>

    </section>

    <!--Distribution-->
    <distributors/>
  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .pb-30 { padding-bottom: 30px; }
  .gridpad { padding: 50px 60px; }
  .gridpad2 { padding: 0px 100px; }
  .hover:hover { color: rgb(var(--primary)); }
  .textACTop { transform: translate(0%, 50%); }

  /*#region Stats*/
  .statsSection {
    background: linear-gradient(135deg, rgb(var(--secondary)), rgba(var(--secondary), 0.82));
    padding: 38px 60px;
  }
  .statsRow { gap: 0; }
  .statItem {
    padding: 18px 20px;
    border-right: 1px solid rgba(255,255,255,0.2);
    max-width: 260px;
  }
  .statItem:last-child { border-right: none; }
  .statNumber { font-size: 46px; font-weight: 800; color: #ffffff; line-height: 1; }
  .statLabel { font-size: 13px; color: rgba(255,255,255,0.8); text-transform: uppercase; letter-spacing: 1px; margin-top: 6px; }
  /*#endregion*/

  /*#region Why Cards*/
  .whySection { background-color: rgb(var(--tierce2)); padding: 60px 60px; }
  .sectionMainTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 28px; text-transform: uppercase; margin-bottom: 8px; }
  .sectionMainSubtitle { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .whyCard {
    position: relative;
    max-width: 320px;
    padding: 28px 22px;
    margin: 12px;
    border-radius: 8px;
    border-top: 4px solid rgb(var(--primary));
    background-color: #ffffff;
    box-shadow: 0 4px 18px rgba(0,0,0,0.08);
    transition: transform 0.35s ease, box-shadow 0.35s ease;
    overflow: hidden;
    animation: slideUpFade 0.6s ease both;
  }
  .whyCard:nth-child(1) { animation-delay: 0.00s; }
  .whyCard:nth-child(2) { animation-delay: 0.12s; }
  .whyCard:nth-child(3) { animation-delay: 0.24s; }
  .whyCard:nth-child(4) { animation-delay: 0.36s; }
  @keyframes slideUpFade {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .whyCard:hover { transform: translateY(-8px); box-shadow: 0 16px 35px rgba(var(--primary), 0.18); }
  .whyCardOverlay {
    position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(var(--primary), 0.88), rgba(var(--secondary), 0.88));
    opacity: 0; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    transition: opacity 0.3s ease; cursor: pointer;
  }
  .whyCard:hover .whyCardOverlay { opacity: 1; }
  .whyCardOverlayText { color: #fff; font-weight: 700; font-size: 18px; text-transform: uppercase; letter-spacing: 1px; }
  .whyCardIcon { font-size: 34px; margin-bottom: 12px; }
  .whyCardTitle { font-size: 19px; color: rgb(var(--primary)); font-weight: 700; margin-bottom: 10px; }
  .whyCardText { font-size: 16px !important; color: rgba(var(--menuColor), 0.65); text-align: justify; line-height: 1.6; }
  /*#endregion*/

  /*#region TypeWater*/
  .sectionTypeWaterLink { color: rgb(var(--secondary)); font-weight: 700; font-size: 24px; text-decoration: none; transition: color 0.2s; }
  .sectionTypeWaterLink:hover { color: rgb(var(--primary)); }
  .bgSectionTypeWaterPhoto1 { background-image: url("../../public/Resources/images/Home/Residentielle-Traitement.jpg"); height: 280px; background-position: center; background-repeat: no-repeat; background-size: cover; border-radius: 6px; transition: transform 0.4s ease; }
  .bgSectionTypeWaterPhoto2 { background-image: url("../../public/Resources/images/Home/Rurale-Traitement.jpg"); height: 280px; background-position: center; background-repeat: no-repeat; background-size: cover; border-radius: 6px; transition: transform 0.4s ease; }
  .bgSectionTypeWaterPhoto3 { background-image: url("../../public/Resources/images/Products/pressureWasher2.jpg"); height: 280px; background-position: center center; background-repeat: no-repeat; background-size: cover; border-radius: 6px; transition: transform 0.4s ease; }
  .bgSectionTypeWaterPhoto4 { background-image: url("../../public/Resources/images/Home/Industrielle-Traitement.jpg"); height: 280px; background-position: center; background-repeat: no-repeat; background-size: cover; border-radius: 6px; }
  .scroll-textes:hover .bgSectionTypeWaterPhoto1,
  .scroll-textes:hover .bgSectionTypeWaterPhoto2,
  .scroll-textes:hover .bgSectionTypeWaterPhoto3 { transform: scale(1.03); }
  .titleAgricole { text-align: left; }
  /*#endregion*/

  /*#region CTA Banner*/
  .ctaBanner {
    height: 480px;
    background-image: url('../../public/Resources/images/Home/equipe-bisson2.jpg');
    background-attachment: fixed;
    background-position: center 40%;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
  }
  .ctaOverlay {
    background-color: rgba(var(--secondary), 0.82);
    padding: 65px 100px;
    border-radius: 12px;
    text-align: center;
    max-width: 820px;
    width: 100%;
  }
  .ctaTitle { color: #ffffff; font-weight: 700; font-size: 36px; margin-bottom: 8px; line-height: 1.2; }
  .ctaSubtitleSmall { color: rgba(255,255,255,0.90); font-size: 20px; font-weight: 500; margin-bottom: 20px; font-style: italic; }
  .ctaText { color: rgba(255,255,255,0.85); font-size: 18px; margin-bottom: 32px; line-height: 1.7; text-align: justify; }
  .ctaText strong { color: #ffffff; font-weight: 700; }
  .ctaBtns { display: flex; gap: 20px; justify-content: center; flex-wrap: wrap; }
  .ctaBtnPrimary {
    background-color: rgb(var(--primary)); color: #ffffff;
    padding: 16px 40px; border-radius: 4px;
    font-weight: 700; font-size: 16px; text-decoration: none;
    text-transform: uppercase; letter-spacing: 1px;
    transition: background-color 0.25s, transform 0.25s;
  }
  .ctaBtnPrimary:hover { background-color: rgba(var(--primary), 0.82); transform: translateY(-2px); }
  .ctaBtnSecondary {
    background-color: transparent; color: #ffffff;
    padding: 16px 40px; border-radius: 4px;
    border: 2px solid rgba(255,255,255,0.8);
    font-weight: 700; font-size: 16px; text-decoration: none;
    text-transform: uppercase; letter-spacing: 1px;
    transition: background-color 0.25s, transform 0.25s;
  }
  .ctaBtnSecondary:hover { background-color: rgba(255,255,255,0.15); transform: translateY(-2px); }
  /*#endregion*/

  /*#region Témoignages*/
  .testimonialsSection { background-color: rgb(var(--tierce2)); padding: 70px 60px; }
  .testimonialsTag { font-size: 13px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; color: rgb(var(--primary)); margin-bottom: 8px; }
  .testimonialsTitle { color: rgb(var(--secondary)); font-size: 30px; font-weight: 800; text-transform: uppercase; margin-bottom: 14px; }
  .testimonialsStars { display: flex; align-items: center; justify-content: center; gap: 4px; }
  .starIcon { color: #FFC107; font-size: 22px; }
  .testimonialsRating { font-size: 15px; color: rgba(var(--menuColor), 0.6); margin-left: 8px; }
  .testimonialsRow { padding: 0 20px; }
  .testimonialsCol { padding: 12px; }

  /* Card */
  .testimonialCard {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 28px 24px;
    height: 100%;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    border-bottom: 4px solid rgb(var(--primary));
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;
  }
  .testimonialCard:hover { transform: translateY(-6px); box-shadow: 0 14px 35px rgba(0,0,0,0.12); }
  .testimonialCard::before {
    content: '\201C';
    position: absolute;
    top: 16px; right: 24px;
    font-size: 80px;
    line-height: 1;
    color: rgba(var(--primary), 0.10);
    font-family: Georgia, serif;
  }

  /* Header */
  .testimonialHeader { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
  .testimonialAvatar {
    width: 44px; height: 44px; border-radius: 50%; flex-shrink: 0;
    background: linear-gradient(135deg, rgb(var(--secondary)), rgb(var(--primary)));
    color: #fff; font-size: 18px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
  }
  .testimonialMeta { flex: 1; }
  .testimonialName { font-size: 16px; font-weight: 700; color: rgb(var(--secondary)); margin: 0; }
  .testimonialDate { font-size: 12px; color: rgba(var(--menuColor), 0.5); margin: 0; }
  .testimonialGoogleIcon { margin-left: auto; }

  /* Stars + Text */
  .testimonialStars { margin-bottom: 12px; }
  .starIconSmall { color: #FFC107; font-size: 16px; }
  .testimonialText { font-size: 15px !important; color: rgba(var(--menuColor), 0.7); line-height: 1.7; text-align: justify; font-style: italic; margin: 0; }

  /* Bouton */
  .testimonialsBtn {
    display: inline-block;
    border: 2px solid rgb(var(--secondary));
    color: rgb(var(--secondary));
    padding: 12px 30px;
    border-radius: 4px;
    font-weight: 700; font-size: 14px;
    text-decoration: none; text-transform: uppercase; letter-spacing: 1px;
    transition: background-color 0.25s, color 0.25s;
  }
  .testimonialsBtn:hover { background-color: rgb(var(--secondary)); color: #ffffff; }
  /*#endregion*/
  .sectionTeamTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .sectionTeamSubtitle { color: rgba(var(--menuColor), 0.8); font-weight: 500; font-size: 22px; }
  .bgSectionTeam { background-color: rgb(var(--tierce2)); }
  .bgSectionTeamPhoto1 { background-image: url("../../public/Resources/images/Home/equipe-bisson2.jpg"); height: 700px; background-position: center; background-repeat: no-repeat; background-size: cover; }
  .sectionTeamTextPad { padding: 225px 200px 0px 45px; }
  /*#endregion*/

  /*#region Scroll animations*/
  .scroll-textes { opacity: 0; transform: translateX(-50px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .scroll-textes.is-visible { opacity: 1; transform: translateX(0); }
  .scroll-textes-right { opacity: 0; transform: translateX(50px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .scroll-textes-right.is-visible { opacity: 1; transform: translateX(0); }
  .scroll-textes-up { opacity: 0; transform: translateY(40px); transition: opacity 0.7s ease, transform 0.7s ease; }
  .scroll-textes-up.is-visible { opacity: 1; transform: translateY(0); }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .forageBandSvg { display: none; }
    /* Stats : grille 2x2 sur mobile */
    .statsSection { padding: 20px 15px; }
    .statsRow { flex-wrap: wrap !important; gap: 0 !important; }
    .statItem { 
      flex: 0 0 50% !important; max-width: 50% !important;
      border-right: none !important;
      border-bottom: 1px solid rgba(255,255,255,0.15);
      padding: 16px 10px;
    }
    .statItem:nth-child(odd)  { border-right: 1px solid rgba(255,255,255,0.15) !important; }
    .statItem:nth-child(3), .statItem:nth-child(4) { border-bottom: none; }
    .statNumber { font-size: 30px; }
    .statLabel { font-size: 11px; }
    /* Témoignages */
    .testimonialsSection { padding: 40px 15px; }
    .testimonialCard { padding: 20px 16px; }
    .testimonialText { text-align: left; font-size: 14px !important; }
    .testimonialsTitle { font-size: 22px; }
    /* Autres */
    .whySection { padding: 40px 15px; }
    .whyCard { max-width: 100%; margin: 8px 0; }
    .ctaBanner { background-attachment: scroll; height: auto; min-height: 380px; }
    .ctaOverlay { padding: 35px 20px; }
    .ctaTitle { font-size: 24px; }
    .ctaSubtitle { font-size: 17px; }
    .gridpad { padding: 25px 15px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .forageBandSvg { display: none; }
    .gridpad { padding: 0px 25px 50px 25px; }
    .textACTop { transform: unset; }
    .ctaBanner { background-attachment: scroll; }
    .sectionTeamTextPad { padding: 25px 30px 30px 30px; }
    .bgSectionTeamPhoto1 { height: 300px; }
    .whySection { padding: 40px 25px; }
    .forageTextWrap { padding: 30px 25px; }
    .forageRight { min-height: 280px; }
    .forageImgWrap { min-height: 280px; }
    .forageServicesGrid { grid-template-columns: 1fr; }
    .forageThumb { height: 70px; }
    .testimonialsSection { padding: 50px 20px; }
    .testimonialText { text-align: left; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .titleAgricole { text-align: center; }
    .bgSectionTeamPhoto1 { height: 300px; background-position-y: 33%; background-size: 150%; }
    .sectionTeamTextPad { padding: 25px 30px 30px 30px; }
    .gridpad2 { padding: 0px 25px 50px 25px; }
    .ctaBanner { background-attachment: scroll; }
    .whySection { padding: 40px 30px; }
    .ctaOverlay { padding: 35px 30px; }
    .forageTextWrap { padding: 40px 40px; }
  }

  /*#region Section Forage*/
  .forageSection { background-color: #f5f7fa; overflow: hidden; position: relative; }
  .forageLeft { background-color: #f5f7fa; }
  .forageTextWrap { padding: 55px 60px 45px 70px; }
  .forageTitle { color: rgb(var(--secondary)); font-size: 24px; font-weight: 800; line-height: 1.25; text-transform: uppercase; margin-bottom: 16px; }
  .forageTitleAccent { color: rgb(var(--secondary)); }
  .forageText { color: rgba(var(--menuColor), 0.65); font-size: 15px !important; line-height: 1.7; margin-bottom: 22px; text-align: justify; }
  .forageServicesLabel { display: inline-block; background-color: rgb(var(--secondary)); color: #ffffff; font-size: 13px; font-weight: 700; padding: 7px 20px; border-radius: 3px; margin-bottom: 18px; }
  .forageServicesGrid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px 20px; margin-bottom: 28px; }
  .forageServiceItem { display: flex; align-items: center; gap: 10px; }
  .forageCheck { width: 22px; height: 22px; flex-shrink: 0; background-color: rgb(var(--primary)); border-radius: 50%; display: flex; align-items: center; justify-content: center; }
  .forageServiceText { font-size: 15px; color: rgba(var(--menuColor), 0.75); font-weight: 500; }
  .foragePhotosRow { display: flex; gap: 12px; margin-bottom: 28px; }
  .forageThumb { flex: 1; height: 90px; border-radius: 12px; background-position: center; background-repeat: no-repeat; background-size: cover; box-shadow: 0 3px 10px rgba(0,0,0,0.15); }
  .forageBtn { display: inline-block; background-color: rgb(var(--primary)); color: #ffffff; padding: 12px 30px; border-radius: 4px; font-weight: 700; font-size: 14px; text-decoration: none; text-transform: uppercase; letter-spacing: 1px; transition: background-color 0.25s, transform 0.25s; }
  .forageBtn:hover { background-color: rgb(var(--secondary)); transform: translateY(-2px); }
  .forageRight { position: relative; min-height: 500px; }
  .forageImgWrap { position: relative; height: 100%; min-height: 500px; }
  .forageImg { position: absolute; inset: 0; background-position: center; background-repeat: no-repeat; background-size: cover; }
  .forageBandSvg {
    position: absolute;
    left: calc(50% - 40px);
    top: 0;
    height: 100%;
    width: 80px;
    z-index: 10;
    pointer-events: none;
  }
  /*#endregion*/
</style>




<script>
    import pageTranslations from '../../public/Resources/i18N/home.json'
    import distributors from '../components/distributors.vue';
    import diapo from '../components/diapo.vue';
    import pumps from '../components/pumps.vue';
    import services from '../components/services.vue';
  
    export default {
    name: 'Home',
    data: () => ({
      testimonials: [
        {
          name: 'Sophie Pronovost',
          date: 'Il y a un an',
          text: "Super service rapide ! Je n'avais plus d'eau suite à une surcharge causée par la foudre qui avait endommagé une boite de connexion. J'ai appelé l'avant-midi et eu un service de réparation en début d'après-midi. Les deux jeunes hommes étaient très gentils et patients avec toutes mes questions. Merci encore pour le dépannage ! Je recommande fortement.",
        },
        {
          name: 'Alexandre Charron',
          date: 'Il y a 3 mois',
          text: "Super service de Antoine. Un samedi de décembre et il s'est déplacé pour un problème d'eau chez moi. Bisson service solide service et recommander à 100%.",
        },
        {
          name: 'Christophe Lambert',
          date: 'Il y a 2 mois',
          text: "Impeccable, très compétent et rapide, merci.",
        },
      ],
      forageServices: [
        'Forage de puits',
        'Installation traitement d\'eau',
        'Installation de pompe',
        'Service clé en main',
      ],
      foragePhotos: [
        '/Resources/images/Forage/forage-1.jpg',
        '/Resources/images/Forage/forage-2.jpg',
        '/Resources/images/Forage/forage-3.jpg',
      ],
      stats: [
        { number: '65+',   label: "Ans d'expérience" },
        { number: '5000+', label: 'Clients satisfaits' },
        { number: '24h',   label: "Service d'urgence" },
        { number: '160km', label: 'Rayon de service' },
      ],
      whyCards: [
        { icon: '🏆', title: 'Expertise reconnue',   text: "Depuis 1958, Bisson Service est le spécialiste de référence en traitement d'eau et systèmes de pompage dans la région." },
        { icon: '⚡', title: 'Intervention rapide',  text: "Nos techniciens certifiés interviennent rapidement, même en urgence, pour minimiser l'impact sur vos activités." },
        { icon: '🔧', title: 'Service complet',      text: "De l'analyse à l'installation, en passant par la réparation et l'entretien — nous couvrons tous vos besoins en eau." },
        { icon: '✅', title: 'Qualité garantie',     text: "Des produits et équipements sélectionnés parmi les meilleures marques, installés par des professionnels certifiés." },
      ],
      Skills: [
        {
          icon: '/Resources/images/icon/Analyse-deau.png',
          hoverIcon: '/Resources/images/icon/Analyse-deau_hover.png',
          link: '/analyseEau',
          linktitle: 'skillsSection.emergency'
        },
        {
          icon: '/Resources/images/icon/traitement-eau.png',
          hoverIcon: '/Resources/images/icon/traitement-eau_hover.png',
          link: '/filtre_a_eau',
          linktitle: 'skillsSection.treatmentResidential'
        },
        {
          icon: '/Resources/images/icon/Pompe-a-eau.png',
          hoverIcon: '/Resources/images/icon/Pompe-a-eau_hover.png',
          link: '/pompe_a_eau_residentielle',
          linktitle: 'skillsSection.treatmentAgricultural',
        },
        {
          icon: '/Resources/images/icon/reparation-moteur.png',
          hoverIcon: '/Resources/images/icon/reparation-moteur_hover.png',
          link: '/reparation_pompe_de_piscine',
          linktitle: 'skillsSection.treatmentCommercial',
        },
        {
          icon: '/Resources/images/icon/reparation-moteur-electriqueV2-Noir.png',
          hoverIcon: '/Resources/images/icon/reparation-moteur-electriqueV2.png',
          link: '/reparation_moteurs_electriques',
          linktitle: 'skillsSection.repairPump',
        },
        {
          icon: '/Resources/images/icon/pompe-industrielle.png',
          hoverIcon: '/Resources/images/icon/pompe-industrielle_hover.png',
          link: '/pompes_agricoles_commerciales_industrielles',
          linktitle: 'skillsSection.repairEngine',
        },
        {
          icon: '/Resources/images/icon/Lavage-a-pression_icon_noir.png',
          hoverIcon: 'Resources/images/icon/Lavage-a-pression_icon.png',
          link: '/pompes_agricoles_commerciales_industrielles',
          linktitle: 'skillsSection.artesianWell',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'skillsSection.pressureController',
        }
      ],
      Pumpes: [
        {
          icon: '/Resources/images/icon/Analyse-deau.png',
          hoverIcon: '/Resources/images/icon/Analyse-deau_hover.png',
          link: '/analyseEau',
          linktitle: 'Pompe submersible'
        },
        {
          icon: '/Resources/images/icon/traitement-eau.png',
          hoverIcon: '/Resources/images/icon/traitement-eau_hover.png',
          link: '/filtre_a_eau',
          linktitle: 'Pompe égout'
        },
        {
          icon: '/Resources/images/icon/Pompe-a-eau.png',
          hoverIcon: '/Resources/images/icon/Pompe-a-eau_hover.png',
          link: '/pompe_a_eau_residentielle',
          linktitle: 'Pompe puisard',
        },
        {
          icon: '/Resources/images/icon/reparation-moteur.png',
          hoverIcon: '/Resources/images/icon/reparation-moteur_hover.png',
          link: '/reparation_pompe_de_piscine',
          linktitle: 'Pompe piston',
        },
        {
          icon: '/Resources/images/icon/reparation-moteur-electriqueV2-Noir.png',
          hoverIcon: '/Resources/images/icon/reparation-moteur-electriqueV2.png',
          link: '/reparation_moteurs_electriques',
          linktitle: 'Pompe prominent',
        },
        {
          icon: '/Resources/images/icon/pompe-industrielle.png',
          hoverIcon: '/Resources/images/icon/pompe-industrielle_hover.png',
          link: '/pompes_agricoles_commerciales_industrielles',
          linktitle: 'Pompe sécurité',
        },
        {
          icon: '/Resources/images/icon/Lavage-a-pression_icon_noir.png',
          hoverIcon: 'Resources/images/icon/Lavage-a-pression_icon.png',
          link: '/pompes_agricoles_commerciales_industrielles',
          linktitle: 'Pompe circulation chauffage',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe diaphragme',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe transfert',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe piscine',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe spa',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe irrigation',
        },
        {
          icon: '/Resources/images/icon/Pieces-et-accessoires.png',
          hoverIcon: '/Resources/images/icon/Pieces-et-accessoires_hover.png',
          link: '/pieces_et_accessoires',
          linktitle: 'Pompe booster pompe',
        }
      ],
      campaignVisible: false,
      townVisible: false,
      waterMachineVisible: false,
      agriculturalVisible: false,
      teamVisible: false,
    }),
    async mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      await this.createObserver();
    },
    methods: {
      async createObserver() {
            // Options pour l'IntersectionObserver
            const options = { threshold: 0.5, }; // La section est visible lorsqu'elle est à 50% dans la vue
            
            // Créer un nouvel observateur Service
            const observer = new IntersectionObserver(this.handleIntersectionServices, options);       
            const targetCampaign = this.$refs.observedCampaign;
            const targetTown = this.$refs.observedTown;
            const targetWaterMachine = this.$refs.observedWaterMachine;
            const targetAgricultural = this.$refs.observedAgricultural;
            const targetTeam = this.$refs.observedTeam;

            if (targetCampaign) { observer.observe(targetCampaign);}
            if (targetTown) { observer.observe(targetTown);  }
            if (targetWaterMachine) { observer.observe(targetWaterMachine);  }
            if (targetAgricultural) { observer.observe(targetAgricultural);  }
            if (targetTeam) { observer.observe(targetTeam);  }
      },
      handleIntersectionServices(entries) {
        entries.forEach((entry) => {
          let e = entry.target.id;
          switch (e) {
            case 'campaign':
              if (entry.isIntersecting) { this.campaignVisible = true; } 
              else { this.campaignVisible = false; }
              break;
            case 'town':
              if (entry.isIntersecting) { this.townVisible = true; } 
              else { this.townVisible = false; }
              break;

            case 'waterMachine':
              if (entry.isIntersecting) { this.waterMachineVisible = true; } 
              else { this.waterMachineVisible = false; }
              break;
            
            case 'agricultural':
              if (entry.isIntersecting) { this.agriculturalVisible = true; } 
              else { this.agriculturalVisible = false; }
              break;
            
            case 'team':
              if (entry.isIntersecting) { this.teamVisible = true; } 
                else { this.teamVisible = false; }
                break;
              
            default:
              break;
          }
        });
      },
    },
    components: {
      distributors,
      diapo,
      pumps,
      services
    },
  }
</script>